export default "__VITE_ASSET__fZZ$ihvS__"